module.exports = __webpack_public_path__ + "media/brands/schwarzmueller-65665b1f.png";